export const ROBOT_PART_CREATE_SUCCESS = 'ROBOT_PART_CREATE_SUCCESS';

export const createRobotPartSuccess = (robotPart) => ({
  type: ROBOT_PART_CREATE_SUCCESS,
  payload: {
    robotPart,
  },
});
